module.exports = __webpack_public_path__ + "files/8460801534b0b5c48269ba55e967a95c.svg";